<template>
  <div>
    <ListingLayout
      :is-loading="isLoading"
      :meta="meta"
      :headers="_headers"
      :items="list"
      selected-product="cso"
      :product-options="productOptions"
      :filter-names="filterNames"
      search-label="search"
      @filterOption="onFiltersChange"
    >
      <template v-slot:partner="{ item }">
        <div>
          {{
            item.shares?.find((r) => r.dealer_partner_type == "partner")
              ?.dealer_partner_name
          }}
          -
          {{
            item.shares?.find((r) => r.dealer_partner_type == "partner")
              ?.share_percentage
          }}%
        </div>
      </template>
      <template v-slot:dealer="{ item }">
        <div>
          {{
            item.shares?.find((r) => r.dealer_partner_type == "dealer")
              ?.dealer_partner_name
          }}
          -
          {{
            item.shares?.find((r) => r.dealer_partner_type == "dealer")
              ?.share_percentage
          }}%
        </div>
      </template>
      <template v-slot:share_percentage="{ item }">
        <div>{{ item.share_percentage || 0 }}%</div>
      </template>
      <template v-slot:actions="{ item }">
        <v-icon
          v-if="isView"
          class="mr-2"
          small
          @click="editItem(item)"
        >
          mdi-eye
        </v-icon>
        <v-icon
          v-if="isEdit"
          class="mr-2"
          small
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          v-if="isDelete"
          class="mr-2"
          small
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>

      <!-- add Filters -->
      <!-- <template #addFilters> </template> -->
      <!-- add Filters -->

      <!-- Action Modals -->
      <template #actionModals>
        <div>
          <create-rates
            v-if="isCreate"
            :filter-options="options"
          />

          <edit-rates
            v-if="(isView || isEdit) && editModal"
            :is-visible-dialog="editModal"
            :toggle-edit="toggleEditModal"
            :item="selectedRow"
          />
          <confirmation-modal
            v-if="isDelete"
            :is-visible="deleteModal"
            :toggle="toggleDeleteModal"
            :row="selectedRow"
          />
        </div>
      </template>
      <!-- Action Modals -->
    </ListingLayout>
  </div>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
import { mapGetters } from "vuex";
// import { debounce } from "lodash";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    CreateRates: () => import("./dialogs/CreateRevenueShare.vue"),
    EditRates: () => import("./dialogs/EditRevenueShare.vue"),
    ConfirmationModal: () =>
      import("@/components/Modals/ConfirmationModal.vue"),
  },
  mixins: [ListingLayoutMixins],

  data() {
    return {
      module_name: "revenueSharing", //vuex module name which define in Store Index
      permissions: {
        view: "revenue-sharing.view",
        create: "revenue-sharing.list",
        edit: "revenue-sharing.list",
        delete: "revenue-sharing.list",
      },
      //
      filters: {},
      subFilters: {},
      //
      //
      customFilters: {},
      productOptions: [
        { id: "oem", value: "OEM" },
        { id: "cso", value: "CSO" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "revenueSharing/getLoading",
      meta: "revenueSharing/getMeta",
      list: "revenueSharing/getList",
    }),
    _headers() {
      const headers = [
        {
          text: this.$t("id"),
          align: "left",
          sortable: true,
          value: "charge_point_id",
        },
        {
          text: this.$t("tenant_name"),
          align: "left",
          sortable: false,
          value: "tenant_name",
          showAdmin: true,
        },
        ...(this.authUser.user_nature == "fleet"
          ? [
              {
                text: this.$t("manufacturer"),
                align: "left",
                sortable: false,
                value: "tenant_name",
              },
            ]
          : []),
        {
          text: this.$t("location"),
          align: "left",
          sortable: false,
          value: "location_name",
        },
        {
          text: this.$t("partner"),
          align: "left",
          sortable: true,
          value: "partner",
        },

        {
          text: this.$t("dealer"),
          align: "left",
          sortable: false,
          value: "dealer",
        },
        ...(this.isView || this.isEdit || this.isDelete
          ? [
              {
                text: this.$t("actions"),
                align: "left",
                sortable: false,
                value: "actions",
              },
            ]
          : []),
      ];

      // computed headers for showing columns to role based
      return headers.filter(
        (header) =>
          header.showAdmin === undefined ||
          (header.showAdmin != undefined &&
            header.showAdmin === this.authUser.isAdmin)
      );
    },

    filterNames() {
      return ["search", "locations", "charge_point"];
      // if (this.authUser.isAdmin) {
      // } else {
      //   return [];
      // }
    },
  },
  watch: {
    "options.tenant_id": {
      handler: function (val) {
        if (val) {
          const params = { tenant_id: val };
          this.$store.dispatch("csmsChargeStations/LocationsList", params);
        } else {
          this.$store.commit("csmsChargeStations/SET_LOCATION", []);
        }
      },
    },

    options() {
      this.fetchData();
    },
  },
  async mounted() {},
  beforeDestroy() {
    const params = {
      name: "revenue_sharing",
      filters: { ...this.options, ...this.customFilters },
    };
    this.$store.commit("redirect/SET_FILTERS", params);
  },
  methods: {
    async fetchData() {
      const params = { ...this.options, ...this.customFilters };

      await this.$store.dispatch("revenueSharing/list", params).then(() => {
        if (this.options.page > (this.meta?.lastPage || 1)) {
          this.options.page = 1;
        }
      });
    },
    //

    // Confirmation of Delete Row
    async deleteSelectedRow(row) {
      try {
        await this.$store.dispatch("revenueSharing/destroy", row);
        this.$store.dispatch("alerts/success", this.$t("deleted_successfully"));
        if (this.list.length === 0 && this.meta.lastPage == this.options.page) {
          this.options.page -= 1; // Move to the previous page
        }
        this.toggleDeleteModal("close");
        this.fetchData();
      } catch (error) {
        this.$store.dispatch("alerts/error", error.response?.data?.message);
      }
    },
  },
};
</script>
